/** Figma collapsible section header — Grey/400, Poppins Regular 14px */
export const sidebarSectionHeaderLabelClass =
  'text-sm font-normal leading-[1.2] tracking-normal text-grey-400';

/** Figma section list items — Grey/900 #3D3D3D · dark Grey/300 #B0B0B0 */
export const sidebarSectionItemLabelClass =
  ' text-sm font-normal leading-[1.2] tracking-normal text-[#3D3D3D] dark:text-grey-300';
